import React, { Component } from 'react';
import classNames from 'classnames';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import ReactDOM from 'react-dom';
import { Toolbar, Data, Editors, Formatters } from 'react-data-grid-addons';
import _ from 'lodash';
import { UI_HEIGHT } from '../Common/constants';
import CashFormatter from '../Common/cashFormatter';
import { Grid, Row, Col, Panel, Button, DropdownButton, ButtonToolbar, MenuItem, FieldGroup, Input, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
import { Field, FieldArray, reset } from 'redux-form';
import { Selection } from '../Common/selection';
import { InputField, DisabledInputField, ControlledInputField } from '../Common/inputField';
import { DatePicker, DisabledDatePicker, StartOfThisMonthDatePicker } from '../Common/datePicker';
import { SkyLightStateless } from 'react-skylight';
import SalesInventoryInfo from '../../containers/Sales/salesInventoryInfo';
import moment from 'moment';
import ReturnModal from '../../containers/Returns/returnModal';
import { ROOT_URL, ROOT_API_URL, isJML } from "../../actions/root_url";

const isHMM = ROOT_API_URL === 'https://hmm-scm.truckxi.com/api/';
const isLO = ROOT_API_URL === 'https://lonni-scm.truckxi.com/api/' || ROOT_URL === 'https://lonni-scm.truckxi.com/api/';
const isAN = ROOT_API_URL === 'https://asian-scm.truckxi.com/api/' || ROOT_URL === 'https://asian-scm.truckxi.com/api/';

var DropDownEditor = Editors.DropDownEditor;

function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

class CustomerReturnForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object,
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton,

        invoice: {
          rows: [],
          selectedRows: [],
          filters: {},
          sortColumn: null,
          sortDirection: null,
        },
        totalPrice: 0,
        showInventoryOpen: false,
        currentCustomer_id: null,
        selectedInventoryRow: {},
        curRow: '',
        curTotal: 0,
        curCRV: 0,
        curTax: 0,
        curRestock: 0,
        curNotation: '',
        curFinal: 0,
        ReturnFormatter: false,
        IsWeight: false,
        rowChosen: null,
        currentWeights: null,
        backLogWeights: [],
      };

      this.handleResize = this.handleResize.bind(this);
    }

    componentWillMount() {
      if (!this.props.params.id) {
        if (!this.props.currentCustomer) {
          this.context.router.push('/customerReturn/');
        } else {
          this.setState({ currentCustomer_id: this.props.currentCustomer.id });
        }
      } else {
        this.props.fetchSalesReturnDetail(this.props.params.id);
      }
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      const { currentSalesInvoice } = this.props;

      if (!currentSalesInvoice && this.props.currentCustomer) {
        if (this.props.currentCustomer.value) {
          this.props.fetchCustomerItem(this.props.currentCustomer.value);
        }
      } else if (typeof currentSalesInvoice === 'object' && currentSalesInvoice && currentSalesInvoice.SalesReturn_id != null) {
        this.props.fetchSalesReturnDetail(currentSalesInvoice.SalesReturn_id);
      } else if (typeof currentSalesInvoice === 'object' && currentSalesInvoice) { this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice.SalesInvoice_id); } else if (currentSalesInvoice) { this.props.fetchSalesInvoiceCompletedDetail(currentSalesInvoice, 'InvoiceNum'); }
      // this.props.fetchSalesInvoice("1900-01-01", "3000-01-01", null, 7);
    }

    componentWillUnmount() {
      this.props.resetCurrentSalesInvoice();
      window.removeEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.salesInvoiceDetail && !this.props.params.id && nextProps.salesInvoiceDetail != this.props.salesInvoiceDetail) {
        const invoice = { ...this.state.invoice, rows: nextProps.salesInvoiceDetail.Sales_Invoice_Lines, TaxRate: nextProps.salesInvoiceDetail.TaxRate, Savings: nextProps.salesInvoiceDetail.Savings, TotalPrice: nextProps.salesInvoiceDetail.TotalPrice,  };
        //this.props.setValue('customerReturnForm', 'InvoiceNum', { value: nextProps.salesInvoiceDetail.InvoiceNum, label: nextProps.salesInvoiceDetail.InvoiceNum });
        this.props.fetchUnpaidInvoices(nextProps.salesInvoiceDetail.Deliver_Customer_id);
        this.setState({ invoice });
      }
      if (nextProps.salesReturnDetail && this.props.params.id && nextProps.salesReturnDetail != this.props.salesReturnDetail) {
        this.props.fetchUnpaidInvoices(nextProps.salesReturnDetail.Deliver_Customer_id);
        const selectedRows = [...nextProps.salesReturnDetail.Sales_Return_Line];
        for (let i = 0; i < selectedRows.length; i++) {
          selectedRows[i].isSelected = true;
          selectedRows[i].ReturnedQuantity = (selectedRows[i].ReturnedQuantity - selectedRows[i].ReturnQuantity);
        }

        const invoice = {
          ...this.state.invoice, rows: selectedRows, selectedRows, TaxRate: nextProps.salesReturnDetail.TaxRate, Savings: nextProps.salesReturnDetail.Savings, TotalPrice: nextProps.salesReturnDetail.OriginalTotalPrice,
        }; 
        //returnedSavings: nextProps.salesReturnDetail.ReturnedSavings,
        this.setState({ invoice, curRestock: nextProps.salesReturnDetail.RestockingFee, curNotation: nextProps.salesReturnDetail.Note, });
      }
    }

    handleResize(e) {
      this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.oneLineButton });
    }


    formatDate(date) {
      let formattedDate = `${date.getFullYear()}-`;

      formattedDate += `${date.getMonth() + 1}-`;
      if (date.getDate() < 10) {
        formattedDate += `0${date.getDate()}`;
      } else {
        formattedDate += date.getDate();
      }
      return formattedDate;
    }

    calculateFinalTotal(nextProps) {
      let Tax = nextProps.Tax;
      let Promo = nextProps.Promo;
      let RestockingFee = nextProps.RestockingFee;

      if (isNumeric(Tax)) {
        Tax = parseFloat(Tax);
      } else {
        Tax = 0;
      }
      if (isNumeric(Promo)) {
        Promo = parseFloat(Promo);
      } else {
        Promo = 0;
      }
      if (isNumeric(RestockingFee)) {
        RestockingFee = parseFloat(RestockingFee);
      } else {
        RestockingFee = 0;
      }

      return Tax + Promo - RestockingFee;
    }

    closeReturnModal = () => { this.setState({ ReturnModalOpen: false, IsWeight: false }); }

    openWeightModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: true }); }
    openQuantityModule = () => { this.setState({ ReturnModalOpen: true, IsWeight: false }); }

    // remove the set of values from arry1 with the values of arry2
    findIntersect = (arry1, arry2) => {
      const arry3 = [];
      if (arry1) arry1.sort();
      if (arry2) arry2.sort();
      let k = 0;
      for (let i = 0; i < arry1.length; i++) {
        if (k < arry2.length && arry1[i] === arry2[k]) { k++; } else { arry3.push(arry1[i]); }
      }
      return arry3;
    }

    setWeights = (currentRow, currentWeights, currentTotalWeight) => {
      // let backLogWeights = [...this.state.backLogWeights];
      // let newEntry = { currentRow, currentWeights };
      // backLogWeights.push(newEntry);
      // this.setState({backLogWeights});
      const invoice = { ...this.state.invoice };
      const ReturnWeightsList = [];
      const selectedIndexes = [];
      for (let k = 0; k < currentWeights.length; k++) {
        if (currentWeights[k].isSelected) {
          ReturnWeightsList.push(parseFloat(roundTo(parseFloat(currentWeights[k].Weight), 2).toFixed(2)));
        }
      }
      for (let i = 0; i < this.state.invoice.rows.length; i++) {
        if ((currentRow === this.state.invoice.rows[i].SalesOrderLine_id) || (currentRow === this.state.invoice.rows[i].SalesInvoiceLine_id)) {
          invoice.rows[i].ReturnTotalPrice = parseFloat(roundTo(parseFloat(currentTotalWeight) * invoice.rows[i].UnitPrice, 2)).toFixed(2);
          invoice.rows[i].ReturnWeight = parseFloat(currentTotalWeight);
          invoice.rows[i].ReturnWeightsList = [...ReturnWeightsList];
          invoice.rows[i].ReturnQuantity = ReturnWeightsList.length;
          if (this.props.params.id) {
            invoice.rows[i].ReturnCRV = parseFloat(roundTo((invoice.rows[i].CRV) * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
          } else {
            invoice.rows[i].ReturnCRV = parseFloat(roundTo((invoice.rows[i].CRV) * ReturnWeightsList.length), 2).toFixed(2) || invoice.rows[i].ReturnCRV || 0;
          }
          // invoice.rows[i].TotalPrice = parseFloat(ReturnTotalPrice);
        }
      }
      this.setState({ invoice });
    }

    returnTotalWeight(totalWeight) {
      console.log('this is the return weight', totalWeight);
    }

    renderCreditInvoice(unpaidInvoices) {
      const invoiceOptions = [];
      if (unpaidInvoices) {
        unpaidInvoices.map((invoice) => {
          invoiceOptions.push({value: invoice.InvoiceNum, label: invoice.InvoiceNum});
        })
      }
      return (
        <Field name="CreditInvoiceNum" component={Selection} disabled={this.props.params.id} matchPos="any" options={invoiceOptions} />
      );
    }

    renderInvoice() {
      const that = this;
      if (this.props.isLoading && !this.props.error) return <Spinner />;
      else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>;

      // Parameters of the react-data-grid

      const getRows = () => Data.Selectors.getRows(this.state.invoice);

      const getSize = () => getRows().length;

      const rowGetter = (rowIdx) => {
        const rows = getRows();
        return rows[rowIdx];
      };

      // Handle the sortable function

      const handleGridSort = (sortColumn, sortDirection) => {
        const invoice = Object.assign({}, this.state.invoice, { sortColumn, sortDirection });
        this.setState({ invoice });
      };

      const handleRowUpdated = (event) => {
        let e = {...event};
        const rows = getRows(); // this.state.invoice.rows;
        const returnQuantity = parseFloat(rows[e.rowIdx].ReturnQuantity) || 0;
        if(isJML && e.cellKey === 'ReturnBox') {
          let ReturnQuantity = e.updated.ReturnBox ? e.updated.ReturnBox * rows[e.rowIdx].jmlPackageSize1 : '';
          Object.assign(rows[e.rowIdx], {...e.updated, ReturnQuantity});  
          e.cellKey = 'ReturnQuantity';
          e.updated.ReturnQuantity = ReturnQuantity;
        } else {
          Object.assign(rows[e.rowIdx], e.updated);
        }
        if (e.cellKey === 'ReturnQuantity' && (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') ) {
          const invoice = { ...this.state.invoice };
          if (invoice.rows[e.rowIdx].LoadedQuantity && (invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].LoadedQuantity) {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
          }
          if (invoice.rows[e.rowIdx].InvoiceQuantity && (invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].InvoiceQuantity) {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
          }
          if (parseFloat(e.updated.ReturnQuantity) < 0) {
            invoice.rows[e.rowIdx].ReturnQuantity = 0;
          }
          invoice.rows[e.rowIdx].ReturnQuantity = isAN ? parseFloat(e.updated.ReturnQuantity) : Math.trunc(invoice.rows[e.rowIdx].ReturnQuantity);
          invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
            ((invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
            ((invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);

          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
          // console.log('invoice weight', {
          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
          // });
          if (isHMM && invoice.rows[e.rowIdx].MeasureUnit === 'SFT') {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          }          
          if (this.props.params.id) {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          } else {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          }
          this.setState({ invoice });
        } else if (e.cellKey === 'ReturnQuantity' && this.state.invoice.rows[e.rowIdx].ProductType === 'Per-Pound') {
          const invoice = { ...this.state.invoice };
          if (invoice.rows[e.rowIdx].LoadedQuantity && (invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].LoadedQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].LoadedQuantity) { invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity); }
          if (invoice.rows[e.rowIdx].InvoiceQuantity && (invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity) < parseFloat(e.updated.ReturnQuantity)) {
            invoice.rows[e.rowIdx].ReturnQuantity = invoice.rows[e.rowIdx].InvoiceQuantity - invoice.rows[e.rowIdx].ReturnedQuantity;
          } else if (invoice.rows[e.rowIdx].InvoiceQuantity) {
            invoice.rows[e.rowIdx].ReturnQuantity = parseFloat(e.updated.ReturnQuantity);
          }
          if (parseFloat(e.updated.ReturnQuantity) < 0) {
            invoice.rows[e.rowIdx].ReturnQuantity = 0;
          }
          invoice.rows[e.rowIdx].ReturnQuantity = Math.trunc(invoice.rows[e.rowIdx].ReturnQuantity);
          invoice.rows[e.rowIdx].ReturnWeight = (invoice.rows[e.rowIdx].LoadedQuantity) ?
            ((invoice.rows[e.rowIdx].TotalNetWeight / invoice.rows[e.rowIdx].LoadedQuantity) * invoice.rows[e.rowIdx].ReturnQuantity) :
            ((invoice.rows[e.rowIdx].InvoiceWeight / invoice.rows[e.rowIdx].InvoiceQuantity) * invoice.rows[e.rowIdx].ReturnQuantity);

          invoice.rows[e.rowIdx].ReturnWeight = +roundTo(invoice.rows[e.rowIdx].ReturnWeight, 2).toFixed(2);
          // console.log('invoice weight', {
          //   check: invoice.rows[e.rowIdx].ReturnWeight, totalWeight: invoice.rows[e.rowIdx].TotalNetWeight, quantity: (invoice.rows[e.rowIdx].LoadedQuantity) ? invoice.rows[e.rowIdx].LoadedQuantity : invoice.rows[e.rowIdx].InvoiceQuantity, ReturnQuantity: invoice.rows[e.rowIdx].ReturnQuantity,
          // });
          invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnTotalPrice, 2)).toFixed(2);
          if (this.props.params.id) {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          } else {
            invoice.rows[e.rowIdx].ReturnCRV = parseFloat(roundTo((invoice.rows[e.rowIdx].CRV) * parseFloat(e.updated.ReturnQuantity), 2)).toFixed(2) || invoice.rows[e.rowIdx].ReturnCRV || 0;
          }
          this.setState({ invoice });
        }
        if (e.cellKey === 'UnitPrice') {
          const invoice = { ...this.state.invoice };
          // Update Return Total Price
          invoice.rows[e.rowIdx].UnitPrice = +parseFloat(roundTo(rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
          if (this.state.invoice.rows[e.rowIdx].ProductType === 'Fixed' || this.state.invoice.rows[e.rowIdx].ProductType === 'Non-Product') {
            if (isHMM && invoice.rows[e.rowIdx].MeasureUnit === 'SFT') {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice * Number(invoice.rows[e.rowIdx].PackageSize_1), 2)).toFixed(2);
            } else {
              invoice.rows[e.rowIdx].ReturnTotalPrice = parseFloat(roundTo(invoice.rows[e.rowIdx].ReturnQuantity * invoice.rows[e.rowIdx].UnitPrice, 2)).toFixed(2);
            }
          } else {
            invoice.rows[e.rowIdx].ReturnTotalPrice = (invoice.rows[e.rowIdx].ReturnWeight * invoice.rows[e.rowIdx].UnitPrice);
          }
          this.setState({ invoice });
        }
        if (e.cellKey === 'ReturnReason') {
          const invoice = { ...this.state.invoice };
          invoice.rows[e.rowIdx].ReturnReason = e.updated.ReturnReason;
          this.setState({ invoice });
        }
      };

      // const returnReasonOptions = [
      //   { id: 0, title: 'Damaged' },
      //   { id: 1, title: 'Defective' },
      //   { id: 2, title: 'Not Needed' },
      //   { id: 3, title: 'Repair' },
      //   { id: 4, title: 'Wrong Item' },
      //   { id: 5, title: 'Other' },
      //   { id: 6, title: 'Missing' },
      // ];

      const returnReasonOptions = [
        'Damaged',
        'Defective',
        'Not Needed',
        'Repair',
        'Wrong Item',
        'Other',
        'Missing',
        'Out',
        'Short',
      ];

      const IsVariableFormatter = React.createClass({
        render() {
          return (<span><Button
            bsStyle="danger"
            className="textAlignStyle"
            style={{ height: '23px', width: '39px', padding: '0px' }}
            onClick={() => {
                    const ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum);
                  }}
          >X
                        </Button>
          </span>);
        },
      });

      const onRowsSelected = (rows) => {
        const newRows = getRows();
        const selectedRows = [...this.state.invoice.selectedRows];
        rows.map((r) => {
          newRows[r.rowIdx].isSelected = true;
          if (!newRows[r.rowIdx].Restock) { newRows[r.rowIdx].Restock = 0; }
          selectedRows.push(r.row);
        });
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };

      const onRowsDeselected = (rows) => {
        const newRows = [...this.state.invoice.rows];
        const selectedRows = [...this.state.invoice.selectedRows];
        selectedRows.map((r, index) => {
          if (r.Product_id === rows[0].row.Product_id) {
            selectedRows.splice(index, 1);
          }
        });
        newRows.map((r, index) => {
          if (r.Product_id === rows[0].row.Product_id) {
            newRows[index].isSelected = false;
          }
        });
        const invoice = { ...this.state.invoice, rows: newRows, selectedRows };
        this.setState({ invoice });
      };
      // let reasonEditor = <DropDownEditor options={returnReasonOptions} />;
      // let reasonFormattor = <DropDownFormatter options={returnReasonOptions} value='bug' />;

      const IsFixedFormatter = React.createClass({
        render() {
          if (this.props.dependentValues.ProductType === 'Non-Fixed') {
            return <span>{this.props.value} <label className="label label-success"><Translate value="non_fixed" /></label></span>;
          } else if (this.props.dependentValues.ProductType === 'Per-Pound') {
            return <span>{this.props.value} <label className="label label-primary"><Translate value="per_pound" /></label></span>;
          }
          return <span>{this.props.value}</span>;
        },
      });

      const ReturnWeightFormatter = React.createClass({
        render() {
          // if (this.props.dependentValues.ReturnQuantity)
          //   return (
          //       (this.props.dependentValues.ProductType === "Non-Fixed") ?
          //         <span>{(this.props.dependentValues.ReturnWeight ||  this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span> :
          //         <span>{
          //           (this.props.dependentValues.LoadedQuantity) ?
          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.LoadedQuantity) * this.props.dependentValues.ReturnQuantity) :
          //           ((this.props.dependentValues.TotalNetWeight/this.props.dependentValues.InvoiceQuantity) * this.props.dependentValues.ReturnQuantity)
          //         }</span>
          //   );
          // else {
          return (<span>{(this.props.dependentValues.ReturnWeight || this.props.dependentValues.ReturnWeight === 0) ? this.props.dependentValues.ReturnWeight : ''}</span>);
          // }
        },
      });

      const ReturnFormatter = React.createClass({
        render() {
          if (this.props.dependentValues) {
            if (!this.props.dependentValues.ReturnQuantity && this.props.dependentValues.ProductType === 'Non-Fixed') {
              return (
                <div><Button
                  bsStyle="primary"
                  className="textAlignStyle"
                  style={{ height: '20px', width: '120px', padding: '0px' }}
                  disabled={!this.props.dependentValues.isSelected}
                  onClick={() => {
                    const currentWeights = { ...this.props.dependentValues };
                    currentWeights.Weights = [...this.props.dependentValues.ReturnableWeightsList];
                    that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                    that.openWeightModule(this.props.dependentValues);
                  }}
                ><Translate value="process" />
                      </Button>
                </div>);
            } else if (this.props.dependentValues.ProductType === 'Fixed' || this.props.dependentValues.ProductType === 'Non-Product' || this.props.dependentValues.ProductType === 'Per-Pound') {
              return (
                <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>
              );
            }
            return (
              <span>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '20px', width: '60px', padding: '0px' }}
                disabled={!this.props.dependentValues.isSelected}
                onClick={() => {
                  const currentWeights = { ...this.props.dependentValues };
                  currentWeights.Weights = [...this.props.dependentValues.ReturnableWeightsList];
                  that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                  that.openWeightModule(this.props.dependentValues);
                }}
              ><Translate value="change" />
              </Button>
              </span>);
          }
        },
      });
      const ReturnBoxFormatter = React.createClass({
        render() {
          if (this.props.dependentValues) {
                return (
                  <span>{(this.props.dependentValues.ReturnBox || this.props.dependentValues.ReturnBox === 0) ? this.props.dependentValues.ReturnBox : ''}</span>
                );
            }
        },
      });


      const ReturnFormatter2 = React.createClass({
        render() {
          if (this.props.dependentValues) {
            return (this.props.dependentValues.ProductType === 'Non-Fixed') ?
              <span style={{ 'padding-right': '5px' }}>{(this.props.dependentValues.ReturnQuantity)}{' '}<Button
                bsStyle="warning"
                className="textAlignStyle"
                style={{ height: '20px', width: '60px', padding: '0px' }}
                disabled={!this.props.dependentValues.isSelected}
                onClick={() => {
                    /* var ProductNum = this.props.dependentValues.ProductNum;
                    that.removeRow(ProductNum); */
                    const currentWeights = {};
                    currentWeights.Weights = [...this.props.dependentValues.InvoiceWeightsList];
                    that.setState({ rowChosen: this.props.dependentValues.SalesInvoiceLine_id, currentWeights });
                    that.openWeightModule(this.props.dependentValues);
                  }}
              ><Translate value="change" />
                                                                                                         </Button>
              </span> :
              <span>{(this.props.dependentValues.ReturnQuantity || this.props.dependentValues.ReturnQuantity === 0) ? this.props.dependentValues.ReturnQuantity : ''}</span>;
          }
        },
      });

      const TotalPriceFormatter = React.createClass({
        render() {
          return (
            (that.props.params.id) ?
              <span>{(this.props.dependentValues.ProductType === 'Fixed') ?
                      parseFloat(roundTo(this.props.dependentValues.ReturnQuantity * this.props.dependentValues.UnitPrice, 2)).toFixed(2) :
                      parseFloat(roundTo(this.props.dependentValues.ReturnWeight * this.props.dependentValues.UnitPrice, 2)).toFixed(2)
                    }
              </span> :
              <span>{this.props.dependentValues.TotalPrice}</span>
          );
        },
      });

      const columns = (!this.props.params.id) ?
        [
          {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          },
          {
            key: 'RefNum',
            name: <Translate value="ref_num" />,
            resizable: true,
            sortable: true,
            width: 100,
            // filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="name" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 160,
            // filterable: true,
          },
          {
            key: 'UnitPrice',
            name: <Translate value="unit_price" />,
            resizable: true,
            sortable: true,
            editable: row => ((row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected),
            width: 80,
            // filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'LoadedQuantity',
            name: <Translate value="inv_qty" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: IsFixedFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'TotalNetWeight',
            name: <Translate value="inv_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
          },
          {
            key: 'ReturnedQuantity',
            name: <Translate value="rtned_qty" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
          },
          ...isJML ? [
            {
              key: 'jmlBox',
              name: <Translate value="box" />,
              resizable: true,
              sortable: true,
              width: 110,
            },
            {
              key: 'jmlPackageSize1',
              name: <Translate value="pcs/box" />,
              resizable: true,
              sortable: true,
              width: 110,
            },
            {
              key: 'ReturnBox',
              name: <Translate value="return_box" />,
              resizable: true,
              sortable: true,
              editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected),
              width: 130,
              // filterable: true,
              formatter: ReturnBoxFormatter,
              getRowMetaData: row => row,
            },
          ] : [],
          {
            key: 'ReturnQuantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            sortable: true,
            editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected) && !isJML,
            width: 130,
            // filterable: true,
            formatter: ReturnFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnWeight',
            name: <Translate value="rtn_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: ReturnWeightFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnTotalPrice',
            name: <Translate value="total_price" />,
            resizable: true,
            sortable: true,
            width: 100,
            // filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'ReturnReason',
            name: <Translate value="return_reason" />,
            resizable: true,
            sortable: true,
            editor: <DropDownEditor options={returnReasonOptions}/>,
          },
        ] :
        [
          {
            key: 'ProductNum',
            name: <Translate value="product_num" />,
            resizable: true,
            sortable: true,
            width: 110,
            // filterable: true,
          },
          {
            key: 'Name',
            name: <Translate value="name" />,
            resizable: true,
            sortable: true,
            width: 140,
            // filterable: true,
          },
          {
            key: 'Description',
            name: <Translate value="description" />,
            resizable: true,
            sortable: true,
            width: 150,
            // filterable: true,
          },
          {
            key: 'UnitPrice',
            name: <Translate value="unit_price" />,
            resizable: true,
            sortable: true,
            editable: row => ((row.SalesInvoiceLine_id === null || row.SalesInvoiceLine_id === undefined) && row.isSelected),
            width: 120,
            // filterable: true,
            formatter: CashFormatter,
          },
          {
            key: 'InvoiceQuantity',
            name: <Translate value="inv_qty" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: IsFixedFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'InvoiceWeight',
            name: <Translate value="inv_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
          },
          {
            key: 'ReturnedQuantity',
            name: <Translate value="rtned_qty" />,
            resizable: true,
            sortable: true,
            width: 110,
            // filterable: true,
          },
          ...isJML ? [
            {
              key: 'jmlBox',
              name: <Translate value="box" />,
              resizable: true,
              sortable: true,
              width: 110,
            },
            {
              key: 'jmlPackageSize1',
              name: <Translate value="pcs/box" />,
              resizable: true,
              sortable: true,
              width: 110,
            },
            {
              key: 'ReturnBox',
              name: <Translate value="return_box" />,
              resizable: true,
              sortable: true,
              editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected),
              width: 130,
              // filterable: true,
              formatter: ReturnBoxFormatter,
              getRowMetaData: row => row,
            },
          ] : [],
          {
            key: 'ReturnQuantity',
            name: <Translate value="return_qty" />,
            resizable: true,
            sortable: true,
            editable: row => (row.ProductType !== 'Non-Fixed' && row.isSelected),
            width: 100,
            // filterable: true,
            formatter: ReturnFormatter2,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnWeight',
            name: <Translate value="rtn_wt" />,
            resizable: true,
            sortable: true,
            width: 80,
            // filterable: true,
            formatter: ReturnWeightFormatter,
            getRowMetaData: row => row,
          },
          {
            key: 'ReturnTotalPrice',
            name: <Translate value="total_price" />,
            resizable: true,
            sortable: true,
            width: 120,
            // filterable: true,
            formatter: CashFormatter,
            // formatter:  TotalPriceFormatter,
            // getRowMetaData: (row) => row,
          },
          {
            key: 'ReturnReason',
            name: <Translate value="return_reason" />,
            resizable: true,
            sortable: true,
            editor: <DropDownEditor options={returnReasonOptions}/>,
          },
        ];
      
      if(isLO) {
        const refIndex = columns.findIndex(column => column.key === 'RefNum');
        if(refIndex !== -1) {
          columns[refIndex].name = <Translate value="item_num" />;
        }
        const nameIndex = columns.findIndex(column => column.key === 'Name');
        if(nameIndex !== -1) {
          columns[nameIndex].name = <Translate value="description" />;
        }
        const productNumIndex = columns.findIndex(column => column.key === 'ProductNum');
        if(productNumIndex !== -1) {
          columns.splice(productNumIndex, 1);
        }
        const descriptionIndex = columns.findIndex(column => column.key === 'Description');
        if(descriptionIndex !== -1) {
          columns.splice(descriptionIndex, 1);
        }
      }

      return (
        <Row>
          <Col sm={12}>
            <div id="CustomerReturnForm-dataGrid1">
              <ReactDataGrid
                rowKey="Product_id"
                onGridSort={handleGridSort}
                columns={columns}
                headerRowHeight={45}
                rowHeight={35}
                rowGetter={rowGetter}
                rowsCount={getSize()}
                onRowUpdated={handleRowUpdated}
                minHeight={this.state.tableHeight}
                // onGridRowsUpdate={() => { console.log('grid row updating'); }}
                enableRowSelect="single"
                enableCellSelect
                rowSelection={{
                          showCheckbox: true,
                          onRowsSelected,
                          onRowsDeselected,
                          selectBy: {
                            isSelectedKey: 'isSelected',
                          },
                        }}
              />
            </div>
          </Col>
        </Row>


      );
    }

    checkValues = (selected) => {
      for (let i = 0; i < selected.length; i++) {
        if (!selected[i].ReturnQuantity || selected[i].ReturnQuantity === null || selected[i].ReturnQuantity === 0) {
          alert('Quantity cannot be zero or blank, if you want to remove a row please deselect it');
          return false;
        }
      }
      return true;
    }

    handleComplete = (TotalPrice, Tax, CRV, RestockingFee, FinalPrice, Note, Redeliver, ReturnedSavings) => {
      let ReturnStatus = false;
      for (let i = 0; i < this.state.invoice.selectedRows.length; i++) {
        if (!this.state.invoice.selectedRows[i].ReturnReason) {
          ReturnStatus = true;
          i = this.state.invoice.selectedRows.length;
        }
      }
      if (!ReturnStatus) {
        if (!this.props.params.id) {
          if (this.checkValues(this.state.invoice.selectedRows)) {
            this.props.createSalesReturn(
              this.props.salesInvoiceDetail.InvoiceNum,
              TotalPrice,
              Tax,
              CRV,
              RestockingFee,
              FinalPrice,
              Note,
              this.state.invoice,
              this.props.salesInvoiceDetail.SalesInvoice_id,
              (this.props.CreditInvoiceNum)? this.props.CreditInvoiceNum.value : '',
              this.props.PostingDate,
              Redeliver,
              ReturnedSavings,
            );
          }
        } else if (this.checkValues(this.state.invoice.selectedRows)) {
          this.props.editSalesReturn(
            this.props.salesReturnDetail.SRNum,
            TotalPrice,
            Tax,
            CRV,
            RestockingFee,
            FinalPrice,
            Note,
            this.state.invoice,
            this.props.params.id,
            (this.props.CreditInvoiceNum)? this.props.CreditInvoiceNum.value : '',
            this.props.PostingDate,
            ReturnedSavings,
          );
        }
      } else {
        alert('Please specify a Return Reason(s) for issuing credit');
      }
    }


    handleRestock = (e) => {
      if (typeof parseFloat(e.target.value, 10) !== 'NaN' && (e.target.value !== '')) {
        const curRestock = e.target.value;
        const invoice = { ...this.state.invoice };
        this.setState({ curRestock, invoice });
      } else if (e.target.value === '') {
        this.setState({ curRestock: '' });
      }
    }

    handleNotation = (e) =>{
      this.setState({curNotation: e.target.value});
    }

    render() {
      const createDialogInventoryStyle = {
        height: '700px',
        width: '1000px',
        marginLeft: '-28%',
        marginTop: '-20%',
      };
      const createDialogStyleWeight = {
        width: '500px',
        height: '600px',
        top: '45%',
        marginLeft: '-10%',
      };
      const selectInventoryInformation = (<Translate value="select_inventory_information" />);
      const salesInvoiceDetail = (!this.props.params.id) ? this.props.salesInvoiceDetail : this.props.salesReturnDetail;
      if (this.props.salesReturnDetail && this.props.salesReturnDetail.SRNum) { salesInvoiceDetail.InvoiceNum = (this.props.params.id) ? this.props.salesReturnDetail.SRNum.slice(0, -1) : salesInvoiceDetail.InvoiceNum; }
      const { handleSubmit } = this.props;
      let Customer_Name = '';
      if (salesInvoiceDetail) {
        Customer_Name = (salesInvoiceDetail.Customer_Name) ? salesInvoiceDetail.Customer_Name : salesInvoiceDetail.Deliver_Customer_Name;
      }
      let tax = 0;
      let total = 0;
      let CRV = 0;
      let finalPrice = 0;
      for (let i = 0; i < this.state.invoice.selectedRows.length; i++) {
        total += (this.state.invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0;
        if (this.state.invoice.selectedRows[i].IsTaxable && this.state.invoice.selectedRows[i].ReturnTotalPrice) { tax += (this.state.invoice.selectedRows[i].ReturnTotalPrice) ? roundTo(parseFloat(this.state.invoice.selectedRows[i].ReturnTotalPrice), 2) : 0; }
        CRV += +roundTo(parseFloat(this.state.invoice.selectedRows[i].CRV || 0) * (parseFloat(this.state.invoice.selectedRows[i].ReturnQuantity) || 0), 2).toFixed(2);
      }
      total = parseFloat(roundTo(total, 2)).toFixed(2);
      CRV = parseFloat(roundTo(CRV, 2)).toFixed(2);

      let discountSpread = 0;
      let returnedSavings = 0;
      discountSpread = (this.state.invoice.Savings && this.state.invoice.TotalPrice) ? ( this.state.invoice.Savings / this.state.invoice.TotalPrice ) : 0;
      returnedSavings = parseFloat(roundTo(total*discountSpread, 2)).toFixed(2);

      if ((tax > 0) && (tax - returnedSavings >= 0)) {
        tax = tax - returnedSavings;
      } else {
        tax = 0;
      }
      let taxr = this.state.invoice.TaxRate;
      if (isAN && salesInvoiceDetail && salesInvoiceDetail.Reseller) {
        taxr = 0;
      }
      tax *= (parseFloat(taxr || 0) / 100.0);
      tax = parseFloat(roundTo(tax, 2)).toFixed(2);

      finalPrice = parseFloat(roundTo((parseFloat(total) || 0) + (parseFloat(CRV) || 0) + (parseFloat(tax) || 0) - (parseFloat(this.state.curRestock) || 0) - (parseFloat(returnedSavings) || 0), 2)).toFixed(2);
      
      return (
        <ContentWrapper>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="returns" />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Translate value="sales_return" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active="true">
              {(!this.props.params.id) ? <Translate value="create_sales_return" /> : <Translate value="edit_sales_return" />}
            </Breadcrumb.Item>
          </Breadcrumb>
          <ButtonToolbar id="breadcrumbButtonGroup">
            {
              !this.props.params.id &&
              <Button
                bsStyle="success"
                disabled={this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating}
                onClick={() => { this.handleComplete(total, tax, CRV, this.state.curRestock, finalPrice, this.state.curNotation, true, returnedSavings); }}
              >
                <span><em className="fa fa-check" /><Translate value="redeliver" /></span>
              </Button>
            }
            <Button
              bsStyle="success"
              disabled={this.state.invoice.selectedRows.length === 0 || this.props.salesReturnIsCreating}
              onClick={() => { this.handleComplete(total, tax, CRV, this.state.curRestock, finalPrice, this.state.curNotation, false, returnedSavings); }}
            >
              {(!this.props.params.id) ?
                <span><em className="fa fa-check" /><Translate value="complete_return" /></span> :
                <span><em className="fa fa-save" /><Translate value="save" /></span>
              }
            </Button>
            <Button
              bsStyle="danger"
              type="button"
              onClick={() => { (this.props.params.id) ? this.context.router.push('/inventoryReturn') : this.context.router.push('/customerReturn'); }}
            >
              <em className="fa fa-close" /><Translate value="cancel" />
            </Button>
          </ButtonToolbar>
          <br />
          <Grid id="sales-customer-return-form" >
            {/* <Row>
              <Col xs={12}>
                <h1>{(!this.props.params.id) ? <Translate value="create_sales_return" /> : <Translate value="edit_sales_return" />}</h1>
              </Col>
            </Row> */}
            <Row>
              <Col xs={8}>
                <Panel>
                  <Row>
                    <Col sm={3}>
                      <Row>
                        <Col xs={12}>
                            <h3><Translate value="customer" /></h3>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={6}>
                            <label><Translate value="name" />:</label>
                          </Col>
                        <Col xs={6}>
                            {Customer_Name}
                          </Col>
                      </Row>

                    </Col>
                    {(salesInvoiceDetail && salesInvoiceDetail.SalesInvoice_id) ?
                      <Col xs={3}>
                        <Row>
                            <Col xs={12}>
                              <h3><Translate value="invoice" /></h3>
                            </Col>
                          </Row>
                        <Row>
                            <Col xs={2}>
                              <label><Translate value="no" />:</label>
                            </Col>
                            <Col xs={7}>
                              {salesInvoiceDetail && salesInvoiceDetail.InvoiceNum}
                            </Col>
                          </Row>
                        <Row>
                            <Col xs={2}>
                              <label><Translate value="sales" />:</label>
                            </Col>
                            <Col xs={7}>
                              {salesInvoiceDetail && salesInvoiceDetail.Sales_User_Name}
                            </Col>
                          </Row>
                      </Col> :
                      <Col xs={3} />
                      }
                    <Col xs={3}>

                      <Row>
                        <Col xs={12}>
                            <h3><Translate value="credit_invoice" /></h3>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={4}>
                            <label><Translate value="no" />:</label>
                          </Col>
                        <Col xs={8}>
                            { this.renderCreditInvoice(this.props.unpaidInvoices) }
                          </Col>
                      </Row>

                    </Col>
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                            <h3><Translate value="return" /></h3>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="no" />:</label>
                          </Col>
                        <Col xs={7}>
                            {
                              (salesInvoiceDetail && salesInvoiceDetail.SRNum) ?
                              salesInvoiceDetail && salesInvoiceDetail.SRNum :
                              salesInvoiceDetail && (`${salesInvoiceDetail.InvoiceNum}R`)
                            }
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="return_date" />:</label>
                          </Col>
                        <Col xs={7}>
                            <Field name="PostingDate" selected={moment().format('MM-DD-YY')} component={StartOfThisMonthDatePicker} />
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={5}>
                            <label><Translate value="user" />:</label>
                          </Col>
                        <Col xs={7}>
                            {salesInvoiceDetail && salesInvoiceDetail.Modifier_User_Name /* right? */}
                          </Col>
                      </Row>
                    </Col>
                  </Row>
                </Panel>
              </Col>
              <Col xs={4}>
                <Panel>
                  <Row>
                    <Col xs={12}>
                      <h3><Translate value="return_details" /></h3>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label style={{ display: 'inline-flex' }}><Translate value="total" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="ReturnTotal" component={DisabledInputField} placeholder={total} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="crv" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="CRV" component={DisabledInputField} placeholder={CRV} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="tax" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="Tax" component={DisabledInputField} placeholder={tax} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={3}>
                      <Row>
                        <Col xs={12}>
                          <label><Translate value="discount" />:</label>
                        </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                          <Field name="Savings" component={DisabledInputField} placeholder={'-' + returnedSavings} />
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={2}>
                      <Row>
                        <Col xs={12}>
                            <label style={{ display: 'inline-flex' }}><Translate value="final" /><span className="dollar-sign"> $$</span>:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Field name="FinalTotal" component={DisabledInputField} placeholder={finalPrice} />
                          </Col>
                      </Row>
                    </Col>
                  </Row>

                  <Row style={{marginTop: '10px'}}>
                  <Col xs={4}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="restocking_fee" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curRestock" type="number" onChange={this.handleRestock} value={this.state.curRestock} />
                          </Col>
                      </Row>
                    </Col>
                    <Col xs={7}>
                      <Row>
                        <Col xs={12}>
                            <label><Translate value="notation" />:</label>
                          </Col>
                      </Row>
                      <Row>
                        <Col xs={12}>
                            <Input name="curNotation" type="text" onChange={this.handleNotation} value={this.state.curNotation} />
                          </Col>
                      </Row>
                    </Col>
                  </Row>

                </Panel>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                <Panel>
                  { this.renderInvoice() }
                </Panel>
              </Col>
            </Row>
          </Grid>

          <SkyLightStateless
            dialogStyles={createDialogStyleWeight}
            isVisible={this.state.ReturnModalOpen}
            onCloseClicked={() => { this.closeReturnModal(); }}
            title="Return Products"
          >
            <ReturnModal
              invoice
              setWeights={this.setWeights}
              keepLoaded={() => {}}
              currentWeights={this.state.currentWeights}
              allWeights={this.state.invoiceWeightsList}
              closeC={this.closeReturnModal}
              rowChosen={this.state.rowChosen}
              returnTotalWeight={this.returnTotalWeight.bind(this)} />
          </SkyLightStateless>

          <SkyLightStateless
            dialogStyles={createDialogInventoryStyle}
            isVisible={this.state.showInventoryOpen}
            onCloseClicked={() => {
              this.closeShowInventory('productSearch');
}}
            title={selectInventoryInformation}
          >
            <SalesInventoryInfo
              Customer_id={this.state.currentCustomer_id}
              SearchType={this.props.searchType}
              SearchValue={this.props.searchValue}
              closeShowInventory={this.closeShowInventory}
              selectInventoryInfo={this.selectInventoryInfo}
              setSaleRowValue={this.props.setSaleRowValue}
              setAllProductQuantity={this.setAllProductQuantity}
              formName="customerReturnForm"
            />
          </SkyLightStateless>
        </ContentWrapper>
      );
    }
}

const renderTypeRadios = props => (
  <div className="form-group" id="search-product-by">
    <label className="col-xs-3 search-by-max-width">
      <Translate value="search_by" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="ProductNum"
        checked={props.input.value === 'ProductNum'}
      />
      <Translate value="prod_num" />
    </label>
    <label className="col-xs-2">
      <input
        {...props.input}
        type="radio"
        value="RefNum"
        checked={props.input.value === 'RefNum'}
      />
      <Translate value="ref_num" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Name"
        checked={props.input.value === 'Name'}
      />
      <Translate value="name" />
    </label>
    <label className="col-xs-2" >
      <input
        {...props.input}
        type="radio"
        value="Description"
        checked={props.input.value === 'Description'}
      />
      <Translate value="description" />
    </label>
  </div>
);

export default CustomerReturnForm;

function roundTo(n, digits) {
  if (digits === undefined) {
    digits = 0;
  }

  const multiplicator = Math.pow(10, digits);
  n = parseFloat((n * multiplicator).toFixed(11));
  const test = (Math.round(n) / multiplicator);
  return +(test.toFixed(2));
}



// WEBPACK FOOTER //
// ./master/jsx/components/Returns/customerReturnForm.jsx